<template>
  <div class="content">
    <div class="steps">
      <check-personal-data />
      <check-address />
      <check-send-quotation v-if="configApp.isOperator" />
      <check-terms-and-conditions v-else-if="configApp.isEmployee" />
      <check-payment v-else />
    </div>
    <div class="informations">
      <check-info-payment v-if="!configApp.isEmployee" />
      <check-info-insurance />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CheckPersonalData from '@/components/organisms/PersonalData/index.vue'
import CheckAddress from '@/components/organisms/Address.vue'
import CheckPayment from '@/components/organisms/Payment.vue'
import CheckTermsAndConditions from '@/components/organisms/TermsAndConditions.vue'
import CheckSendQuotation from '@/components/organisms/SendQuotation.vue'
import CheckInfoPayment from '@/components/organisms/InfoPayment.vue'
import CheckInfoInsurance from '@/components/organisms/InfoInsurance.vue'

export default {
  name: 'DeskCheckout',
  data () {
    return {
      showModal: false,
      isVisible: true
    }
  },
  computed: {
    ...mapState(['configApp']),
    ...mapState(['product', 'steps'])
  },
  components: {
    CheckPersonalData,
    CheckAddress,
    CheckPayment,
    CheckSendQuotation,
    CheckTermsAndConditions,
    CheckInfoPayment,
    CheckInfoInsurance
  }

}
</script>
<style lang="scss" scoped>
  .content {
    @media screen and (min-width: 1080px) {
      display: flex;
      justify-content: space-between;
    }
  }

  .steps {
    width: 100%;

    @media screen and (min-width: 768px) {
      div:not(:first-child) {
        margin-top: 16px;
      }
    }

    @media screen and (min-width: 1280px) {
      margin-right: 16px;
      max-width: 848px;
      min-width: 572px;
    }
  }

  .informations {
    width: 100%;
    @media screen and (min-width: 768px) and (max-width: 1279px) {
      display: none;
    }

    @media screen and (min-width: 1280px) {
      max-width: 416px;
    }

    .card:not(:first-child) {
      margin-top: 16px;
    }
  }
</style>
